import { ArrowLeftIcon, ArrowNarrowLeftIcon, ArrowRightIcon, ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/outline';
import { ChevronDoubleRightIcon } from '@heroicons/react/solid';
import { StaticImage } from 'gatsby-plugin-image'
import React, {useState} from 'react'

export default function Testimonial() {
  const testimonials = [
    {
      name: 'Gino Epis',
      title: 'CEO at Essenza (YES ZEE)',
      quote: 'We have been working with Sara Fashion Wear for years, for us it is synonymous with reliability and safety. In addition to providing us with an excellent product quality, they are able to guarantee the best realization of our collections within the agreed timeframe.',
      profileImage: <StaticImage src='../images/testimonials/epis.jpg' className='mx-auto h-16 w-16 rounded-full' alt='Gino Epis' />,
      logoImage: <StaticImage src='../images/client-logos/yes-zee.png' className='mx-auto h-12' alt='' objectFit='contain'/>,
    },
    {
      name: 'Stefano Introini',
      title: 'CEO at SITEX',
      quote: "It's hard not to quickly fall comfortable with Sara Fashionwear. I have worked with them for years and they never failed to deliver the maximum quality products with the best customer service.",
      profileImage: <StaticImage src='../images/testimonials/stefano.jpg' className='mx-auto h-16 w-16 rounded-full' alt='Stefano Introini' />,
      // logoImage: <StaticImage src='../images/client-logo/yes-zee.jpg' className='mx-auto h-8' alt='' />,
    },
    {
      name: 'Romain Pottier',
      title: 'General Manager at Movin (Sergio Tacchini)',
      quote: 'I work with SARA Fashion for more than 10 years. I can explain the longevity of this relationship by the quality, the service and the adaptability I have always found with this supplier. SARA Fashion has always done its best to satisfy our process, timing and requirement. I am sure we still have a lot of years to work together.',
      profileImage: <StaticImage src='../images/testimonials/romain.jpg' className='mx-auto h-16 w-16 rounded-full' alt='Romain Pottier' />,
      logoImage: <StaticImage src='../images/client-logos/sergio-tacchini.png' className='mx-auto h-12' alt='' objectFit='contain'/>,
    },
    {
      name: 'Eleonora Giussani',
      title: 'Product Manger at Marville',
      quote: 'Sarafashion is a certainty for our brand, their products have the highest quality and the team supports us in a complete and professional way. They are able to understand our requests and they help us to create a great result without ever missing a season.',
      profileImage: <StaticImage src='../images/testimonials/eleonora.jpg' className='mx-auto h-16 w-16 rounded-full' alt='Eleonora Giussani' />,
      logoImage: <StaticImage src='../images/client-logos/sergio-tacchini.png' className='mx-auto h-12' alt='' objectFit='contain'/>,
    },
    // {
    //   name: 'Vittorio Bossi',
    //   title: 'Country Manager at Incom (U.S. Polo Assn.)',
    //   quote: 'Working with Sara Fashionwear is an experience like no other in this line of work. They are serious about the quality they upkeep. With them promises are held. There is never a worry about deadlines.',
    //   profileImage: <StaticImage src='../images/testimonials/vittorio.jpg' className='mx-auto h-16 w-16 rounded-full' alt='' />,
    //   logoImage: <StaticImage src='../images/client-logos/us-polo.png' className='mx-auto ' alt='' objectFit='contain'/>,
    // },
  ]

  const randomSelection = Math.floor(Math.random() * testimonials.length)
  const [active, setActive] = useState(randomSelection);

  const nextQuote = () => {
    if (active >= testimonials.length - 1) {
      setActive(0)
    } else {
      const updated = active + 1
      setActive(updated)
    }
  } 

  const previousQuote = () => {
    if (active <= 0) {
      setActive(testimonials.length - 1)
    } else {
      const updated = active - 1
      setActive(updated)
    }
  } 

  const selected = testimonials[active]

    return (
      <section className="relative rounded-sm bg-gray-100 max-w-7xl mx-auto pb-2 lg:pb-0">
        <div className='absolute h-full w-full flex lg:hidden items-end justify-center z-50 -bottom-5'>
          <button className='cursor-pointer bg-primary-500 hover:bg-primary-700 py-2 px-6 rounded-sm text-gray-900' onClick={() => nextQuote()}>
            More testimonials
          </button>
        </div>
        <div className='absolute hidden lg:flex h-full items-center z-50 lg:-left-3'>
          <button className='cursor-pointer bg-primary-300 hover:bg-primary-500 py-4 px-6 rounded-sm text-gray-700' onClick={() => previousQuote()}>
            <ArrowLeftIcon className='h-6'/>
          </button>
        </div>
        <div className='absolute h-full hidden lg:flex  right-0 items-end lg:items-center z-50 lg:-right-3'>
          <button className='cursor-pointer bg-primary-300 hover:bg-primary-500 py-4 px-6 rounded-sm text-gray-700' onClick={() => nextQuote()}>
            <ArrowRightIcon className='h-6'/>
          </button>
        </div>
        <div className="py-12 md:py-20 lg:py-24 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="relative overflow-hidden">
            <div className='w-36 mx-auto'>
              {selected.logoImage ? selected.logoImage : null}
            </div>
            <blockquote className="mt-10">
              <div className="max-w-3xl mx-auto text-center text-xl leading-9 text-gray-900">
                <p>
                  &ldquo;{selected.quote}&rdquo;
                </p>
              </div>
              <footer className="mt-8">
                <div className="md:flex md:items-center justify-center">
                  <div className="flex md:flex-shrink-0 justify-center">
                    {selected.profileImage}
                  </div>
                  <div className="mt-3 text-center md:mt-0 md:ml-4 md:flex md:items-center">
                    <div className="text-base font-medium text-gray-900">{selected.name}</div>
  
                    <svg className="hidden md:block mx-1 h-5 w-5 text-primary-500" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M11 0h3L9 20H6l5-20z" />
                    </svg>
  
                    <div className="text-base font-medium text-gray-700">{selected.title}</div>
                  </div>
                </div>
              </footer>
            </blockquote>
          </div>
        </div>
      </section>
    )
  }